module.exports = __webpack_public_path__ + "img/Error-icon.9c505314.svg";